<template>
    <div>
        <el-form :inline="true" size="mini" class="demo-form-inline" label-width="120px" ref="declareForm" :model="declareForm">
           <el-form-item label="报关单类型" prop="type">
                <el-select clearable placeholder="请选择报关单类型" :default-first-option="true" v-model="declareForm.type">
                    <el-option v-for="item in queryDeclarationTypeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeName">
                        <span class="margin_right_20">{{ item.codeValue }}</span>
                        <span >{{ item.codeName }}</span> 
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="进出口标志" prop="ieFlag">
                <el-select clearable placeholder="请选择进出口标志" :default-first-option="true" v-model="declareForm.ieFlag">
                    <el-option v-for="item in importsExportsCodeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                        <span class="margin_right_20">{{ item.codeValue }}</span>
                        <span >{{ item.codeName }}</span> 
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="报关单号" prop="entryNo">
                <el-input clearable class="width_193" placeholder="请输入报关单号" v-model="declareForm.entryNo"></el-input>
            </el-form-item>
            <el-form-item label="统一编号" prop="seqNo">
                <el-input clearable class="width_193" placeholder="请输入统一编号" v-model="declareForm.seqNo"></el-input>
            </el-form-item>
            <el-form-item label="境内收发货人" prop="ownerName">
                <el-select clearable filterable remote :remote-method="getEnterpriseList" :default-first-option="true" placeholder="请选择境内收发货人" 
                v-model="declareForm.ownerName">
                    <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName">
                        <span>{{ item.companyName }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提运单号" prop="billNo">
                <el-input clearable class="width_193" placeholder="请输入提运单号" v-model="declareForm.billNo"></el-input>
            </el-form-item>
            <el-form-item label="申报地海关" prop="customMaster">
                <el-select clearable filterable remote :remote-method="getCustomsList" :default-first-option="true" v-model="declareForm.customMaster"
                placeholder="请选择申报地海关">
                    <el-option v-for="item in customsList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                        <span class="margin_right_20">{{ item.codeValue }}</span>
                        <span >{{ item.codeName }}</span> 
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="报关状态" prop="status">
                <el-select clearable filterable :default-first-option="true" v-model="declareForm.status"
                placeholder="请选择报关状态">
                    <el-option v-for="item in statusList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="是否结关" >
                <el-select filterable :default-first-option="true" placeholder="请选择报关单状态" >
                    <el-option v-for="item in trueORfalse" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                        <span class="margin_right_20">{{ item.codeValue }}</span>
                        <span >{{ item.codeName }}</span> 
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="最近操作时间" >
                <el-date-picker v-model="declareDeta" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                 end-placeholder="结束日期" unlink-panels :picker-options="pickerOptions" @change="getData" >
                </el-date-picker>
            </el-form-item>
            <el-form-item label=" " label-width="0" >
                <el-button size="mini" type="primary" plain round @click="getListBy">查询</el-button>
                <el-button size="mini" type="warning" plain round @click="reset">重置</el-button>
                <!-- <el-button size="mini" type="success" plain round>高级查询</el-button> -->
            </el-form-item>
        </el-form>
        <el-table ref="declareList" :data="declareList" tooltip-effect="dark" @selection-change="declareListChange" style="width: 100%;" size="mini"
        :header-cell-style="{'text-align':'center'}" height="calc(100vh - 448px)" @row-dblclick="details" highlight-current-row>
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column label="统一编号" prop="seqNo" width="150" align="center" sortable ></el-table-column>
            <el-table-column label="海关编号" prop="entryNo" width="150" align="center" sortable></el-table-column>
            <el-table-column label="境内收发货人" width="150"  prop="tradeName" align="center" sortable></el-table-column>
            <el-table-column label="境内收发货人18位社会信用代码" width="220" prop="ownerCodeScc" align="center" sortable ></el-table-column>
            <el-table-column label="提运单号" prop="billNo" width="120" align="center" sortable></el-table-column>
            <el-table-column label="放行日期" prop="entryDate" width="120" align="center" sortable></el-table-column>
            <el-table-column label="进出口日期" prop="ieDate" width="120" align="center" sortable></el-table-column>
            <el-table-column label="监管方式" prop="tradeModeValue" width="120" align="center" sortable></el-table-column>
            <el-table-column label="合同协议号" prop="contrNo" width="120" align="center" sortable></el-table-column>
            <el-table-column label="运输工具名称" width="120" prop="trafName" align="center" sortable></el-table-column>
            <el-table-column label="航次号" prop="voyNo" width="100" align="center" sortable></el-table-column> 
            <el-table-column label="报关状态" prop="status" width="100" align="center" sortable>
                <template slot-scope="scope">
                    <el-link type="primary" style="font-size: 12px !important;" @click.stop="statusClick(scope.row.id)">{{ scope.row.status }}</el-link>
                </template>
            </el-table-column>
            <el-table-column label="初审人" align="center" width="100" sortable prop="inputerName"></el-table-column>
            <el-table-column label="复审人" align="center" width="100" sortable prop="checker"></el-table-column>
            <!-- <el-table-column label="是否查验" align="center" width="100" sortable></el-table-column> -->
            <el-table-column label="申报单位名称" width="200" prop="agentName" align="center" sortable></el-table-column>
            <el-table-column label="进出口标志" prop="ieFlag" width="120" align="center" sortable>
                <template slot-scope="scope">
                    <span v-if="scope.row.ieFlag == 'I'">进口</span>
                    <span v-if="scope.row.ieFlag == 'E'">出口</span>
                </template>
            </el-table-column>
            <el-table-column label="申报地海关" prop="customMasterValue" width="120" align="center" sortable></el-table-column>
            <el-table-column label="入境/离境口岸" width="130" prop="entyPortCodeValue" align="center" sortable></el-table-column>
            <!-- <el-table-column label="集装箱数" ></el-table-column> -->
        </el-table>
        <!-- 状态列表 -->
         <div v-if="declareStatus">
            <el-button class="margin_button" plain type="info" round icon="el-icon-close" size="mini" @click="closeStatus">关闭</el-button>
            <el-table v-if="declareStatus" ref="declareStatusList" :data="declareStatusList" style="width: 100%" size="mini" :header-cell-style="{'text-align':'center'}" height="255px">
                <el-table-column type="index" width="50"  align="center"></el-table-column>
                <el-table-column property="seqNo" label="统一编号" align="center" width="300px"></el-table-column>
                <el-table-column property="entryId" label="海关编号" align="center" width="300px"></el-table-column>
                <el-table-column property="responseCodeText" label="回执状态" align="center" width="300px"></el-table-column>
                <el-table-column property="errorMessage" label="回执详细信息" align="center"></el-table-column>
                <el-table-column property="receiveTime" label="回执时间" width="300px" align="center"></el-table-column>
            </el-table>
         </div>
    </div>
</template>
<script>
import AEObasicData from '@/config/AEObasicData.js'

export default {
    name: 'declareSearch',
    components:{
        
    },
    data() {
        return {
            declareDeta:[],
            declareForm:{
                type:'一般报关单', //报关单类型
                entryNo:'',//报关单号
                billNo:'',//提运单号
                startDate:'',//开始日期
                endDate:'',//结束日期
                seqNo:'',//统一编号
                customMaster:'4258',//申报地海关
                ieFlag:'E',//进出口类型
                ownerName:'',//收发货人
                status:'', // 报关状态
            },
            declareStatus:false, // 状态列表显示
            declareStatusList:[], // 状态列表
            enterpriseList:[], // 企业列表
            importsExportsCodeList:AEObasicData.importsExportsCodeList, // 进出口标志
            CUSDeclarationList:AEObasicData.DEC_ENTRY_TYPE,// 报关单类型
            customsList:[], //海关列表
            queryDeclarationTypeList:AEObasicData.queryDeclarationTypeList,
            trueORfalse:AEObasicData.trueORfalse, // 是/否
            declareList:[],
            pickerOptions: {
                shortcuts: [{
                    text: '当天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            statusList:[
                {
                    codeName: "申报成功",
                    codeValue: "7"
                },{
                    codeName: "审结",
                    codeValue: "J"
                },{
                    codeName: "放行",
                    codeValue: "P"
                },{
                    codeName: "结关",
                    codeValue: "R"
                },{
                    codeName: "已发送",
                    codeValue: "0"
                },{
                    codeName: "查验",
                    codeValue: "C"
                },{
                    codeName: "错误",
                    codeValue: "1"
                }
            ],
            responseList:[
                {
                    codeName: "暂存",
                    codeValue: "0"
                },{
                    codeName: "调箱完成",
                    codeValue: "4"
                },{
                    codeName: "申报成功",
                    codeValue: "7"
                },{
                    codeName: "审结",
                    codeValue: "J"
                },{
                    codeName: "放行",
                    codeValue: "P"
                },{
                    codeName: "查验",
                    codeValue: "C"
                },{
                    codeName: "结关",
                    codeValue: "R"
                },{
                    codeName: "入库成功",
                    codeValue: "L"
                }
            ],
            
        }
    },
    mounted() {
        // 获取今天日期
        const today = new Date(); 
        const year = today.getFullYear();  
        const month = String(today.getMonth() + 1).padStart(2, '0');  
        const day = String(today.getDate()).padStart(2, '0'); 
        this.declareForm.startDate = `${year}-${month}-${day}`;
        this.declareForm.endDate = `${year}-${month}-${day}`;
        this.declareDeta = [ this.declareForm.startDate ,this.declareForm.endDate ]
        // 查申报地海关
        this.getCustomsList(this.declareForm.customMaster)
    },
    methods: {
        // 海关信息
        getCustomsList(value){
            if(value && value !== ' '){
                this.customsList = AEObasicData.CUS_CUSTOMS.filter(item =>
                    item.codeName.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeValue.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 获取企业列表
        getEnterpriseList(value){
            this.$api.getCompanyList(  {companyName:value } ).then(res =>{
                this.enterpriseList = res.tableData
            })
        },
        declareListChange(){

        },
        getData(value){
            if(value){
                this.declareForm.startDate = value[0]
                this.declareForm.endDate = value[1]
            }else{
                this.declareForm.startDate = ''
                this.declareForm.endDate = ''
            }
        },
        getListBy(){
            this.$api.getListBy(this.declareForm).then(res =>{
                this.declareList = res
                // 将code值转换成对应的值
                this.declareList = this.getCodeValue(this.declareList)
            })
        },
        getCodeValue(list){
            list.map(listItem =>{
                // 监管方式
                listItem.tradeModeValue =  AEObasicData.CUS_MAPPING_TRADE_CODE_V.filter(item =>
                    item.codeValue.includes(listItem.tradeMode))[0].codeName
                // 申报地海关
                listItem.customMasterValue =  AEObasicData.CUS_CUSTOMS.filter(item =>
                    item.codeValue.includes(listItem.customMaster))[0].codeName
                // 进境/出境口岸
                listItem.entyPortCodeValue =  AEObasicData.CIQ_PORT_CN.filter(item =>
                    item.codeValue.includes(listItem.entyPortCode))[0].codeName
            })
            return list
        },
        reset(){
            this.declareForm = {
                type:'一般报关单', //报关单类型
                entryNo:'',//报关单号
                billNo:'',//提运单号
                startDate:'',//开始日期
                endDate:'',//结束日期
                seqNo:'',//统一编号
                customMaster:'4258',//申报地海关
                ieFlag:'E',//进出口类型
                ownerName:'',//收发货人
                status:'',
            }
        },
        details(row, column, event){
            var submenuLabel = ''
            var submenuPath = ''
            var submenuName = ''
            // 判断进出口
            if(row.ieFlag === 'E'){
                // 出口
                if(row.type === '备案清单'){
                    // 备案
                    submenuLabel = '出口备案-' + (row.seqNo? row.seqNo :row.billNo)
                    submenuPath = '/exportDeclareML?id=' + row.id
                    submenuName = 'exportDeclareML' + row.id
                    
                }else{
                    submenuLabel = '出口-' + (row.seqNo? row.seqNo :row.billNo)
                    submenuPath = '/exportDeclare?id=' + row.id
                    submenuName = 'exportDeclare' + row.id
                }
            }else{
                // 进口
                if(row.type === '备案清单'){
                    // 备案
                    submenuLabel = '进口备案-' + (row.seqNo? row.seqNo :row.billNo)
                    submenuPath = '/importDeclareML?id=' + row.id
                    submenuName = 'importDeclareML' + row.id
                }else{
                    submenuLabel = '进口-' + (row.seqNo? row.seqNo :row.billNo)
                    submenuPath = '/importDeclare?id=' + row.id
                    submenuName = 'importDeclare' + row.id
                }
            }
            this.$store.commit('addKeepAliveCache', submenuName)
            var submenu = {
                path: submenuPath,
                name: submenuName,
                label: submenuLabel,
            }
            // //修改选中菜单
            this.$store.commit('selectMenu', submenu)
            this.$router.push({
                path: submenuPath,
                query: {
                    id: row.id,
                    entryNo:row.entryNo,
                    seqNo:row.seqNo,
                }
            })
        },
        // 点击查询状态
        statusClick(id){
            this.$api.getStatusListBy(  id ).then(res =>{
                this.declareStatus = true
                this.declareStatusList = res
                this.declareStatusList = this.declareStatusList.map(item =>{
                    item.responseCodeText = this.responseList.filter(items =>
                        items.codeValue.toLowerCase().includes(item.responseCode.toLowerCase())
                    )[0].codeName
                    return {...item}
                })
            })
        },
        // 关闭状态列表
        closeStatus(){
            this.declareStatus = false
            this.declareStatusList = []
        },
        deactivated() {
            this.scrollLeft=this.$refs.left.$refs.bodyWrapper.scrollLeft
        },
        activated() {
            //页面每次激活时 都会获取之前的scrollLeft
            this.$refs.left.$refs.bodyWrapper.scrollLeft=this.scrollLeft
        },
    }
}
</script>
<style lang="css" scoped>
.width_193{
    width: 193px;
}
.margin_right_20{
    margin-right: 20px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    margin-bottom: 5px;
}
.el-table {
    margin-top: 10px;
    /* color: black; */
}
.margin_button{
    margin-top: 5px;
    margin-left: 10px;
    margin-bottom: 5px;
}
::v-deep .el-table__body tr:hover>td {
  background-color: #c4e7ff !important; /* 浅蓝色背景示例 */
}
.el-table {
    margin-top: 0px;
}
</style>